
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../../grpc"

import {
    Timestamp,
} from "../../../google/protobuf/timestamp"

import {
    EnumValue,
} from "../../../google/protobuf/type"

export interface GetCosStsCredentialResponse {
    bucketUrl: string
    bucket: string
    region: string
    keyPrefix: string
    sessionToken: string
    tmpSecretId: string
    tmpSecretKey: string
    expireTime: Timestamp
}

export interface GetCosStsCredentialRequest {
    prefix: EnumValue /* key前缀位置 */
}

export interface ListKeyPrefixesRequest {
}

export interface ListKeyPrefixesResponse {
    prefixes: Array<EnumValue>
}

export interface StorageObject {
    region: string
    bucket: string
    key: string
}

export interface GetCosPresignedRequest {
    fileNameSuffix: string /* 文件名后缀 */
}

export interface GetCosPresignedResponse {
    key: string
    presignedUrl: string
}

export class ObjectStorageService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* 获取cos临时密钥 */
    async getCosStsCredential(request: GetCosStsCredentialRequest): Promise<GetCosStsCredentialResponse> {
        const method = "post"
        const path = "/scanner.v2.ObjectStorageService/GetCosStsCredential"
        return await this.call(method, path, request) as GetCosStsCredentialResponse
    }
    
    /* 获取key前缀列表 */
    async listKeyPrefixes(request: ListKeyPrefixesRequest): Promise<ListKeyPrefixesResponse> {
        const method = "post"
        const path = "/scanner.v2.ObjectStorageService/ListKeyPrefixes"
        return await this.call(method, path, request) as ListKeyPrefixesResponse
    }
    
    /* 获取cos预签名上传链接 */
    async getCosPresigned(request: GetCosPresignedRequest): Promise<GetCosPresignedResponse> {
        const method = "post"
        const path = "/scanner.v2.ObjectStorageService/GetCosPresigned"
        return await this.call(method, path, request) as GetCosPresignedResponse
    }
    
}
